/*
 * RAF first, trailing edge debounce function.
 */
export const debounce = (fn, ms) => {
  let timerId;

  const useRAF = (typeof window.requestAnimationFrame === 'function');

  return function() {
    const execute = () => fn.apply(this, arguments);

    if (useRAF && !ms) {
      window.cancelAnimationFrame(timerId);
      timerId = window.requestAnimationFrame(execute);
    } else {
      window.clearTimeout(timerId);
      timerId = window.setTimeout(execute, ms || 100);
    }
  }
}
